<template>
  <div id='' style='' class='gPageBorder' v-loading='loading'>
    <el-form class='gForm' label-position="right" ref="firm" :rules='rules' label-width="12.5%" :model='firm'>
      <el-form-item :label="$t('app_deviceName')" prop='name'>
        <el-input v-model="firm.name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item :label="$t('app_deviceNo')" prop='no'>
        <el-input v-model="firm.no" placeholder=''></el-input>
      </el-form-item>
      <el-form-item :label="$t('app_distributor')" prop='mech'>
        <MechanismSelector  :data="mechanismData"></MechanismSelector>
      </el-form-item>
      <el-form-item :label="$t('app_type')" prop='type'>
         <el-select v-model="firm.type" :placeholder="$t('app_select')">
            <el-option
              v-for="item in dvs"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select> 
      </el-form-item>
      <el-form-item :label="$t('app_model')" prop='model'>
         <el-select v-model="firm.model" :placeholder="$t('app_select')">
            <el-option
              v-for="item in mds"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item :label="$t('app_firm')" prop='firm'>
         <el-select v-model="firm.firm" :placeholder="$t('app_select')">
            <el-option
              v-for="item in firms"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item :label="$t('app_addres')" prop='addr'>
        <el-input v-model="firm.addr" placeholder=''></el-input>
      </el-form-item>
      <el-form-item :label="$t('lin_global.remark')" prop=''>
        <el-input v-model="firm.remark" placeholder=''></el-input>
      </el-form-item>
      <el-form-item>
        <el-button  type='' style='' @click="cancel">{{$t('app_cancel')}}</el-button>
        <el-button  type='primary' style='' @click="save('firm')">{{$t('app_save')}}</el-button>
      </el-form-item>
    </el-form>
   
  </div>
</template>

<style>
</style>

<script>
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
    data () {
      var _this = this
      var phoneCheck = (rule, value, callback) => {
        if (!this.isLegalMobile(value)) {
          callback(new Error(this.$t('app_phoneIllegal')));
        } else {
          callback()
        }
      }
      return {
        fatherList: [],
        info: '',
        mechanismData: '',
        firm: {
          name: '',
          no: '',
          mech: '',
          type: '',
          model: '',
          firm: '',
          addr: '',
          remark: ''
        },
        firms: [],
        loading: false,
        dvs: [],
        mds: [],
        rules: {
          name: [
            { required: true, message: this.$t('mao_global.tip.pleaseInput'), trigger: 'blur' }
          ],
          no: [
            { required: true, message: this.$t('mao_global.tip.pleaseInput'), trigger: 'blur' }
          ],
          mech: [
            { required: true, message: this.$t('app_select'), trigger: 'blur'/*, validator: phoneCheck*/}
          ],
          type: [
            { required: true, message: this.$t('app_select'), trigger: 'blur' }
          ],
          firm: [
            { required: true, message: this.$t('app_select'), trigger: 'blur' }
          ],
          model: [
            { required: true, message: this.$t('app_select'), trigger: 'blur' }
          ],
          addr: [
            { required: true, message: this.$t('mao_global.tip.pleaseInput'), trigger: 'blur' }
          ],
          remark: [
            { required: true, message: this.$t('mao_global.tip.pleaseInput'), trigger: 'blur' }
          ]
        }
      }
    },
    components: {
       MechanismSelector
    },
    methods: {
      mccallback (vl,notclear) {
        if (!notclear) {
          this.firm.firm = ''
          this.firm.type = ''
          this.firm.model = ''
        }        
        this.getSlData(vl) 
      },
      getSlData (value) {				
				if (!value) {
					this.firms = []
					this.dvs = []
					this.mds = []
					return
				}
				this.$mechGetTypes(value, res => {
					if (res.status == 200) {
						this.mds = res.data.models
						this.dvs = res.data.types
						this.firms = res.data.manufactures
					}
				}, '') 
			},
      getDvNo (index) {
        this.loading = 1
        this.$deviceNo(99999, 1, '', '', (res) => {
          console.log('res', res)
          this.loading = 0
          if (res.status === 200) {
            this.mds = res.data
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      getFirm () { 
        this.loading = 1
        this.$getFirmList(99999, 1, '', '', (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.firms = res.data
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          // error
        })
        
      },
      getDTypes () {
        this.loading = 1
        this.$deviceType(99999, 1, '', '', (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.dvs = res.data
            // console.log('tbd', res.data)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          // error
        })
        
      },
      isLegalMobile (tel) {
        var sMobile = tel
        var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$"
        var re = new RegExp(regex, 'g') 
        if(!(re.test(sMobile))){
          return false
        } else {
          return true
        }
      },
      newfirm () {
        this.loading = 1
        this.$addNonDv(this.firm.no, this.firm.name, this.firm.firm, this.firm.mech, this.firm.addr, this.firm.type, this.firm.model, this.firm.remark, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      editfirm () {
        var data = this.info
        // console.log(this.firm)
        this.loading = 1
        this.$editNonDv(data.id, this.firm.no, this.firm.name, this.firm.firm, this.firm.mech, this.firm.addr, this.firm.type, this.firm.model, this.firm.remark, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
        }) 
      },
      save (name) {
        // console.log(this.firm)
        this.$refs[name].validate((valid) => {
          if (valid) {
            if (!this.info) {
              this.newfirm()
            } else {
              this.editfirm()
            }
          } else {
            return false
          }
        })
      },
      cancel () {
        this.$router.go(-1)
      },
      fillData (data) {
        
        this.firm.name = data.terminalName
        this.firm.no = data.terminalNo
        this.firm.mech = data.mechanismId
        this.firm.type = data.terminalType
        this.firm.model = data.terminalModel
        this.firm.firm = data.manufId
        this.firm.addr = data.address
        this.firm.remark = data.memo
        this.mccallback(data.mechanismId, true)
        
        var _this = this
        this.mechanismData = {
          value: data.mechName,
          placeholder: _this.$t('lin_global.place_areaid'),
          callback (value) {
            _this.firm.mech = value
            _this.mccallback(value)
          }
        }
      }
    },
    mounted () {
      
      // this.getFirm()
      // setTimeout(() => {
      //   this.getDTypes()
      // }, 200);
      // setTimeout(() => {
      //   this.getDvNo()
      // }, 300);



      var data = this.$route.query.data
      this.info = data
      var _this = this
      if (data) {
        this.fillData(data)
      } else {
        this.mechanismData = {
          value: '',
          placeholder: _this.$t('lin_global.place_areaid'),
          callback (value) {
            _this.firm.mech = value
            _this.mccallback(value)
          }
        }
      }

    }
  }
</script>



// WEBPACK FOOTER //
// edit.vue?6f8c2e18